module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._t("body", [_c('iframe', {
    attrs: {
      "width": "700px",
      "height": "500px",
      "src": "https://www.youtube.com/embed/p2XFz7szqzA?si=cRqPWZ-sWb0GByed&enablejsapi=1",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "referrerpolicy": "strict-origin-when-cross-origin",
      "allowfullscreen": ""
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-584a747e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/type/TutorialModal.vue
// module id = 1297
// module chunks = 2